// extracted by mini-css-extract-plugin
export default {"areaFestival":"index_areaFestival_39-0F","navBar":"index_navBar_WpFFX","header":"index_header_LpmqX","areaReports":"index_areaReports_PM-ay","blank50":"index_blank50_6bLU6"};